module.exports = __webpack_public_path__ + "img/desadev.c6d6addb.png";